import React ,{Component} from 'react'; 
import {  NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';

import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Moment from 'react-moment';
import moment from 'moment';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import FormLabel from '@mui/material/FormLabel';


import NativeSelect from '@mui/material/NativeSelect';


 export default class Addleadmaster extends Component {

   constructor(props) {
      super(props);
	  
	  
	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	
	  
	  
	  
	  
  this.state = {
	  
	  ldm_followupdate:Date.now(),ldm_followupdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),rmdate:Date.now(),
	  
	  ldm_reasonforlost:0,ldm_movedtoaddress:'',ldm_dob1:'',
	  ldm_leadsource:'',ldm_other:'',
	  st_id:'',staffdata:[],redirect: false,logredirect:false,ldm_dob:dayjs(Date.now()),dateofbirth:'',
		 	ldm_address:'',ldm_staffattendedby:'',	ldm_referby:'',ldm_dob:'',ldm_gender:0,ldm_lastname:'',ldm_middlename:'',
		   open:false,name:'',ldm_id:0,name:'',type:4,emailid:'',phoneno:'',followupdate:'',errormessage:'',erropen:false,followupdate1:dayjs(moment().toDate(),0),btndisabled:false,
submitbtn:"Save"
	  }
   }
   
   myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;

  this.setState({[nam]: val}); 
 
} 
	  
	  
	  
	 
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  
 
 
 
 
 
   componentDidMount() {
	   document.title = "AthaYog Living - Lead Managment"; 

if(localStorage.getItem("AYLuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
  
	this.StaffidBind();
	 let search = window.location.href;
	 let Prodid = this.getParameterByName('Ldmid',search);
	if(Prodid!==null)
	{  
this.Leadmastergetdata(Prodid);

	}
		
}
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}




 Leadmastergetdata(Prodid) {
	
   axios.get(Serverurl+'ajaxleadmaster.php?action=getall&ldm_id='+Prodid)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
     
      ldm_id:resp.data[0].ldm_id,
	  name: resp.data[0].ldm_firstname,
      emailid: resp.data[0].ldm_emailid,
phoneno: resp.data[0].ldm_phoneno,	  
type: resp.data[0].ldm_type, 
comments: resp.data[0].ldm_comments, 
followupdate: resp.data[0].ldm_followupdate, 
ldm_middlename: resp.data[0].ldm_middlename, 
ldm_lastname: resp.data[0].ldm_lastname, 
ldm_gender: resp.data[0].ldm_gender, 
ldm_dob: resp.data[0].dateofbirth, 

ldm_referby: resp.data[0].ldm_referby, 
ldm_staffattendedby: resp.data[0].ldm_staffattendedby, 
ldm_address: resp.data[0].ldm_address, 
ldm_leadsource: resp.data[0].ldm_leadsource, 
ldm_other: resp.data[0].ldm_other, 
ldm_reasonforlost: resp.data[0].ldm_reasonforlost, 
ldm_movedtoaddress: resp.data[0].ldm_movedtoaddress, 
 ldm_followupdate:resp.data[0].start,ldm_followupdate1:resp.data[0].start,
    
    });

  
	}else{
	 this.setState({  
	    name:'',	 
	 emailid:'',
	 phoneno:'',
	 ldm_id:0,
	 type:4,
	 comments:'',
	 followupdate:'',
	 ldm_middlename:'',
	 ldm_lastname:'',
	 ldm_gender:0,
	 ldm_dob:'',

	 ldm_referby:'',
	 ldm_staffattendedby:'',
	 ldm_address:'',
	 ldm_leadsource:'',
	 ldm_reasonforlost:'',
	ldm_movedtoaddress:'',

	 
	  }); 
 
  
    }
});
	  
 }








 handfrChange = (date) => {
	 var month="",date1="";

	 if((date.getMonth()+ 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
	
     this.setState({ followupdate:date,
followupdate1:date.getFullYear() + '-' + month + '-' +date1
	 })
	
	
  }
	



myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  

  if(nam==="phoneno")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
  
  
  
 
  }
  else{
  this.setState({[nam]: val});
  }
  
 


}
  
  handleSubmit = (event) => {

	
	const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/; 
 let name = this.state.name;
 let emailid = this.state.emailid;
 let phoneno = this.state.phoneno;
  let type = this.state.type;
  let comments = this.state.comments;
  
  
    let ldm_firstname = this.state.ldm_firstname;
    let ldm_middlename = this.state.ldm_middlename;
    let ldm_lastname = this.state.ldm_lastname;
    let ldm_gender = this.state.ldm_gender;
    let dateofbirth = this.state.dateofbirth;
  
  
    let ldm_referby = this.state.ldm_referby;
    let ldm_staffattendedby = this.state.ldm_staffattendedby;
    let ldm_address = this.state.ldm_address;
    let ldm_leadsource = this.state.ldm_leadsource;
    let ldm_other = this.state.ldm_other;
    let ldm_reasonforlost = this.state.ldm_reasonforlost;
    let ldm_movedtoaddress = this.state.ldm_movedtoaddress;
	let ldm_followupdate1=this.state.ldm_followupdate1;
	
	
if(name==="")
{
	
	this.setState({errormessage:"Please Enter Name",erropen:true});		
		 return false;
	
	
}



 if(emailid==="")
{
	this.setState({errormessage:"Please Enter EmailId.",erropen:true});
	return false;
}else{
	
	 if (!remail.test(emailid)) {
	 this.setState({errormessage:"Please Enter Valid Email Id",erropen:true});
		 window.scrollTo({        top: 0     })
	return false; 
  }
}
if(phoneno==="")
{
	
	this.setState({errormessage:"Please Enter Phone No.",erropen:true});		
		 return false;
	
	
}
if(ldm_gender===0)
{
	
	this.setState({errormessage:"Please Select Gender",erropen:true});		
		 return false;
	
	
}
if(type==="")
{
	
	this.setState({errormessage:"Please Select Type",erropen:true});
		 		 return false;
	
	
}



if(type==="5" && ldm_reasonforlost==="")
{
	
	this.setState({errormessage:"Please Select reason",erropen:true});
		 		 return false;
	
	
}




/*
if(ldm_referby==="")
{
	
	this.setState({errormessage:"Please Enter Reffer By",erropen:true});
	
		 return false;
	
	
}




*/


if( ldm_reasonforlost==="1" && ldm_movedtoaddress==="")
{
	
	
	this.setState({errormessage:"Please Enter Moved address",erropen:true});
return false;
	
}




if(ldm_leadsource==="")
{
	
	this.setState({errormessage:"Please Select Source",erropen:true});
return false;
	
	
}

if(ldm_leadsource==="8" && ldm_other==="")
{
	
	this.setState({errormessage:"Please Select Source",erropen:true});
return false;
	
	
}


if(ldm_address==="")
{
	
	this.setState({errormessage:"Please enter address",erropen:true});
return false;
	
	
}









 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  
  
   if(this.state.ldm_id==0)
	  {
		  formData.append('ldm_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('ldm_id',this.state.ldm_id)
		
          }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		formData.append('ldm_firstname',name)
		formData.append('ldm_emailid',emailid)
		formData.append('ldm_phoneno',phoneno)
		formData.append('ldm_type',type)
		formData.append('ldm_comments',comments)
			
		formData.append('ldm_followupdate',ldm_followupdate1)
		formData.append('ldm_middlename',ldm_middlename)	
		formData.append('ldm_lastname',ldm_lastname)	
		formData.append('ldm_gender',ldm_gender)	
		formData.append('ldm_dob',dateofbirth)	
		
		formData.append('ldm_referby',ldm_referby)	
		formData.append('ldm_staffattendedby',localStorage.getItem("AYLuserid"))	
		formData.append('ldm_address',ldm_address)	
		formData.append('ldm_leadsource',ldm_leadsource)	
		formData.append('ldm_other',ldm_other)	
		formData.append('ldm_reasonforlost',ldm_reasonforlost)	
		formData.append('ldm_movedtoaddress',ldm_movedtoaddress)	




	
		formData.append('userid',localStorage.getItem("AYLuserid"))	
		
		axios.post(Serverurl+"ajaxleadmaster.php", formData, {
        }).then(res => {
   if(res.data!=-1)
					{
						
					let strreturn=res.data;
					strreturn=strreturn;
					
					
					
						this.setState({redirect:true,pagename:'/Adminleadmaster'});
					
					//this.setState({open:false,btnsavedisbaled:false,btnsavetxt:'Save',});
				
						
							
							
						}
   
        });
  
	
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save",  });
};

	  
	  
	  
 StaffidBind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall')
	
    
      .then((resp) => {    
     

	  
	  
	  let staffApi = resp.data.map(row => {
                      
          return {value: row.st_id, display:row.st_id}
        });
		
		 this.setState({
          staffdata: [{value: '', display:'Select staffid'}].concat(staffApi)
        },()=>{console.log(this.state.staffdata)});
      }).then(data => {
		 
    
      }) 
    
     


}  
	
	 	
onchangeHandler= (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}
  );
}
   
   
   
   handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ldm_dob:dayjs(date),
dateofbirth:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
   





  handnodateChanges = (date) => {
	
	  var month="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ ldm_followupdate:dayjs(date),
ldm_followupdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }  
  
	  
render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  
 
  
  return (
  

		<React.Fragment>
		<div className="boxheading"><h2>Lead Management</h2></div>
<div className="addandbacbtn"><NavLink to='/Adminleadmaster' >Back</NavLink>
</div>
<div className="clear"></div>
			



	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
	<div className="formmain">		

	<ul>	
						  
	<li><p> <span className="validation">*</span>Fisrt Name</p>
	
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.name}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p></li>
						  
						  
		<li><p>Middle Name</p>
	
	<p><TextField name="ldm_middlename" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ldm_middlename}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  </li>
					


				  
		<li><p>Last Name</p>
	
	<p><TextField name="ldm_lastname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ldm_lastname}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
					
					</li>
					
<li>					  
						  
						  
		 <p> <span className="validation">*</span>Email Id</p>
		<p>
		<TextField name="emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.emailid}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		
		</p>	
</li>
<li>
<p> <span className="validation">*</span>Phone No.</p>
		<p>
		<TextField name="phoneno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.phoneno}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "5",maxLength:10}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		
		</p></li>

		
<li>
 <FormControl>
  <FormLabel id="demo-radio-buttons-group-label">Gender</FormLabel>
  <RadioGroup
    aria-labelledby="demo-radio-buttons-group-label"
    defaultValue="female"
    name="ldm_gender"
	value={this.state.ldm_gender}
	 onChange={this.myChangeHandler} 
	
  >
  <div className="radiobtn">
    <p><FormControlLabel value={1} control={<Radio />} label="Female" /></p>
   <p> <FormControlLabel value={2}control={<Radio />} label="Male" /></p>
    <p> <FormControlLabel value={3} control={<Radio />} label="Other" /></p>
	
	</div>
  </RadioGroup>
</FormControl>
		
</li>




<li>
<p>Date of birth</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.ldm_dob) }
className="txtbox" 
name="ldm_dob"
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>

</li>







<li>		
						  
		<p> <span className="validation">*</span>Type</p>				  
						  <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.type} inputProps={{tabIndex: "9"}} className="txtbox"
		  name="type"
		
        >
	

	 <option value={4}>Enquiry</option>
	 
	 {this.state.ldm_id!==0 && (<React.Fragment>
          <option value={1}>Active</option>
          <option value={2}>In Active</option>
 <option value={3}>Follow Up</option>

 <option value={5}>Lost</option>
	</React.Fragment> )}

        </Select>

		</FormControl>
		</p>
		
		</li>
		
		
		
		
	
		
	
		
		
		
		
		
			
		

 <li style={{"display":"none"}}>
		<p> Staff</p> 
		  <p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		 value= {this.state.ldm_staffattendedby}
          onChange={this.onchangeHandler}
		  
          id="ldm_staffattendedby"
		   value={this.state.ldm_staffattendedby} inputProps={{tabIndex: "10"}} className="txtbox"
		  name="ldm_staffattendedby"
		
		
        >
		{this.state.staffdata.map(br => (
            <option  
            
              value={br.value}
            >
              {br.display}
            </option  >
          ))}
		
        </Select></FormControl>
		</p>
		  </li>

		
		
		
		
		
<li>
		<p> <span className="validation">*</span>Followup Date</p>
	
	<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.ldm_followupdate) } minDate={dayjs(this.state.ldm_followupdate) }
className="txtbox" 
    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
	
		
		



</li>
















<li>
	
	
		 <p> Referred by</p> <p > 
		  
	 <TextField name="ldm_referby" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	 
	   value={this.state.ldm_referby}
			 
			  
			  inputProps={{tabIndex: "13",maxLength:400}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>
	
				
				
		</li>		





<li>		
						  
		<p> <span className="validation">*</span> Source</p>				  
						  <p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.ldm_leadsource} inputProps={{tabIndex: "9"}} className="txtbox"
		  name="ldm_leadsource"
		
        >
	
	<option value="">Select Source</option>
           <option value={1}>Website
</option>
          <option value={2}>
IVR</option>
          <option value={3}>Google</option>
          <option value={4}>Social media</option>
          <option value={5}>Referral</option>
          <option value={6}>Walk In</option>
          <option value={7}>Hoarding</option>
          <option value={8}>Others</option>


        </Select>

		</FormControl>
		</p>
		
		</li>





		
	{this.state.ldm_leadsource === "8"  && ( 	
		<li><p>Other Source</p>
	
	<p><TextField name="ldm_other" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.ldm_other}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  </li>
	)}		
		
	





	

<li>





					  
<p>Comments: </p>
		  
		   <p> 
		  
	 <TextField name="comments" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.comments}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "12",maxLength:400}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>						  

</li>
	

			

<li>	
	
		 <p> Address</p> <p> 
		  
	 <TextField name="ldm_address" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.ldm_address}
			 
			  
			  inputProps={{tabIndex: "14",maxLength:400}} 
	   InputLabelProps={{ shrink: true }}
                          />
		  </p>
</li>
</ul>
</div>
  <p className="aligncentr"> 
		  <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   Submit
</Button></p>

</React.Fragment>
  );
  }
	  
	  
 
	  
	  
	  
	   }